export const AUTH_LOGIN_REQUEST = 'AUTH/LOGIN/REQUEST'
export const AUTH_LOGIN_SUCCESS = 'AUTH/LOGIN/SUCCESS'
export const AUTH_LOGIN_ERROR = 'AUTH/LOGIN/ERROR'

export const AUTH_LOGOUT = 'AUTH/LOGOUT'
export const AUTH_USER = 'AUTH/USER'
